/* eslint-disable */
import React from 'react';
import cn from 'classnames';
import { TreeView, TreeItem } from '@material-ui/lab';
import { useStylesTreeView, useStylesTreeitem } from './styles';
import { useHierarchicalSelector } from './useHierarchicalSelector';
import Input from './Input';
import Search from './Search';
import Popover from './Popover';
import AddBoxOutlinedIcon from '../../../../icons/OpenTree';
import { cloneDeep } from 'lodash';
import RemoveOutlinedIcon from '../../../../icons/CloseTree';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { hierarchiesFindChild, hierarchies, Hierarchy } from '../../../bulkexport';

const useTreeStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '3px',
    },
  },
  box: {
    overflow: 'hidden',
  }
}));
const useParentStyles = makeStyles((theme: Theme) => createStyles({
  root: {

  },
  selected: {
    "& $content": {
      background: "none !important",
    },
    "& $label": {
      background: "none !important",
    }
  },
  content: {
    borderRadius: "4px",
    padding: "6px",
    height: '32px',
  },
  label: {
    color: "rgba(39, 58, 57, 0.8)",
    fontSize: "12px",
    lineHeight: "100%",
    fontWeight: "bold",
    background: "none !important",
  }
}));

const useItemStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    marginBottom: '2px',
    "& $content:hover": {
      background: "rgba(51, 51, 51, 0.05)",
    }
  },
  content: {
    borderRadius: "4px",
    padding: "6px",
    height: '32px',
  },
  label: {
    color: "rgba(39, 58, 57, 0.8)",
    fontSize: "12px",
    lineHeight: "100%",
    fontWeight: "bold",
    background: "none !important",
  },
  selected: {
    "& $content": {
      background: "rgba(101, 172, 30, 0.2)",

    },
    "& $label": {
      background: "none !important",
      color: "#65AC1E",
    }
  },
}));
const mockitems = [{
  id: '1',
  name: 'Item1'
}, {
  id: '2',
  name: 'Item2'
}, {
  id: '3',
  name: 'Item1_1',
  parent: '1'
}, {
  id: '4',
  name: 'Item1_1',
  parent: '1'
}, {
  id: '5',
  name: 'Item2_1',
  parent: '2'

},];

export const Commodities: React.FC<any> = props => {
  const { search, handleSearch } = useHierarchicalSelector();
  const items: any[] = props.items || mockitems;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classesItem = useItemStyles();
  const classesParent = useParentStyles();
  const [checked, setChecked] = React.useState<string[]>([]);

  React.useEffect(() => {
    if (props.value?.length && JSON.stringify(props.value?.map(String)) !== JSON.stringify(checked)) {
      setChecked(props.value.map(String));
    }
  }, [JSON.stringify(props.value)]);

  React.useEffect(() => {
    if (props.onChange && props.value && JSON.stringify(props.value?.map(String)) !== JSON.stringify(checked)) {
      props.onChange(checked);
    }
  }, [JSON.stringify(checked)]);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const treeViewClasses = useTreeStyles();
  const nodes = React.useMemo(() => hierarchies<any>(items.filter(x => !search || x.name.trim().toLocaleLowerCase().includes(search.trim().toLocaleLowerCase())), "id", "parent"), [items, search]);
  const open = Boolean(anchorEl);
  const togglePopover = e => open ? handleClose() : handleClick(e);
  const itemClasses = useStylesTreeitem(props);
  const showSoybean = 'soybean'.includes(search);
  const handleToggle = (e, id) => {
    const node = hierarchiesFindChild(nodes, id);
    if (!Boolean(node?.children.length)) {
      const newChecked = [id];
      setChecked(newChecked);
      handleClose();
    }
  };

  const customNode = (hierarchy: Hierarchy<any>) => {
    if (hierarchy.children.length) {
      return (<TreeItem role="listitem" key={hierarchy.item.name} nodeId={hierarchy.id} label={hierarchy.item.name}
        classes={classesParent}
      >
        {hierarchy.children.map(customNode)}
      </TreeItem>);
    }
    return (<TreeItem role="listitem" key={hierarchy.item.name} nodeId={hierarchy.id} label={hierarchy.item.name}
      classes={classesItem}
    />);
  }

  return <>
    <Input label="Scale" value={items.find(x => x.id === checked[0])?.name} open={open} onClick={togglePopover} />
    <Popover anchorEl={anchorEl} onClose={togglePopover}>
      <Search onChange={handleSearch} />
      {(
        <div className={treeViewClasses.box}>
          <TreeView
            defaultCollapseIcon={<RemoveOutlinedIcon />}
            defaultExpandIcon={<AddBoxOutlinedIcon />}
            role="list"
            className={treeViewClasses.root}
            defaultExpanded={nodes.map(x => x.id)}
            // expanded={Boolean(props.search) ? nodes.map(x => x.id) : undefined}
            selected={checked[0]}
            onNodeSelect={handleToggle}
          >
            {!nodes?.length && '' ? "No results" : null}
            {nodes.map(customNode)}
          </TreeView>
        </div>
      )}
    </Popover>
  </>;
}